import { useEffect, useState } from "react";
import { AdminSettingsListComponent } from "../AdminSettingsListComponent";
import { TableCell, TableRow } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  fetchRecruitmentAreas,
  selectAllRecruitmentAreas,
} from "./recruitmentsSlice";
import { RecruitmentAreaDetailsComponent } from "./RecruitmentAreaDetailsComponent";
import { fetchExpertUsers } from "../../user/expertUsersSlice";
import useIsLoading from "../../../hooks/useIsLoading";
import { useTranslation } from "react-i18next";

export const RecruitmentAreasPanel = () => {
  const [selectedRecruitmentAreaId, setSelectedRecruitmentAreaId] = useState<
    string | null
  >(null);
  const [searchString, setSearchString] = useState("");

  const dispatch = useAppDispatch();
  const recruitmentAreas = useAppSelector(selectAllRecruitmentAreas);
  const isLoading = useIsLoading(["recruitments.recruitmentAreas"]);

  const { t } = useTranslation();

  // at this point, searching is done on the client side, move to backend if needed
  const filteredRecruitmentAreas = recruitmentAreas.filter((recruitmentArea) =>
    recruitmentArea.name.toLowerCase().includes(searchString.toLowerCase()),
  );

  useEffect(() => {
    dispatch(fetchRecruitmentAreas({}));
    dispatch(fetchExpertUsers({}));
  }, [dispatch]);

  const selectRow = (id: string) => {
    setSelectedRecruitmentAreaId(id);
  };

  const rows = filteredRecruitmentAreas.map((recruitmentArea) => (
    <TableRow
      key={recruitmentArea.id}
      onClick={() => selectRow(recruitmentArea.id)}
    >
      <TableCell>{recruitmentArea.name}</TableCell>
    </TableRow>
  ));

  return !selectedRecruitmentAreaId ? (
    <AdminSettingsListComponent
      rows={rows}
      isLoading={isLoading}
      searchString={searchString}
      setSearchString={setSearchString}
      title={t("settings:addRecruitmentArea")}
    />
  ) : (
    <RecruitmentAreaDetailsComponent
      id={selectedRecruitmentAreaId}
      close={() => setSelectedRecruitmentAreaId(null)}
    />
  );
};
